(($, Drupal, once) => {
  Drupal.behaviors.paragraphBio = {
    attach: (context) => {
      once('paragraphBio', '.js-band-bio-component', context).forEach(
        (element) => {
          const $element = $(element);
          const $cardDesc = $element.find('.js-card-desc');
          const numColumns = $element.data('columns');

          const breakpoints = {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200,
            xxl: 1400,
          };

          const getBreakpoint = () => {
            if (window.innerWidth < breakpoints.sm) return breakpoints.xs;
            if (window.innerWidth < breakpoints.md) return breakpoints.sm;
            if (window.innerWidth < breakpoints.lg) return breakpoints.md;
            if (window.innerWidth < breakpoints.xl) return breakpoints.lg;
            if (window.innerWidth < breakpoints.xxl) return breakpoints.xl;
            return breakpoints.xxl;
          };

          const throttle = (callback, delay) => {
            let shouldWait = false;
            let waitingArgs = false;
            const timeoutFunc = () => {
              if (!waitingArgs) {
                shouldWait = false;
              } else {
                callback(...waitingArgs);
                waitingArgs = false;
                setTimeout(timeoutFunc, delay);
              }
            };

            return (...args) => {
              if (shouldWait) {
                waitingArgs = args;
              } else {
                callback(...args);
                shouldWait = true;
                setTimeout(timeoutFunc, delay);
              }
            };
          };
          const setCardHeights = () => {
            // Reset the card heights back to auto
            $cardDesc.css('height', 'auto');

            // Check for a change in the number of columns
            if (
              (window.innerWidth >= breakpoints.sm &&
                window.innerWidth < breakpoints.lg) ||
              (window.innerWidth >= breakpoints.lg && numColumns === 2)
            ) {
              // For each card - always two per column
              $cardDesc.each((index, card) => {
                // Check if there are two cards in the row
                if (index % 2 === 0 && index + 1 < $cardDesc.length) {
                  const $card1 = $(card);
                  const $card2 = $cardDesc.eq(index + 1);

                  // Match the card heights
                  const maxHeight = Math.max(
                    $card1.outerHeight(),
                    $card2.outerHeight(),
                  );

                  $card1.css('height', `${maxHeight}px`);
                  $card2.css('height', `${maxHeight}px`);
                }
              });
            } else if (window.innerWidth >= breakpoints.lg) {
              // Check the number of columns
              if (numColumns === 3) {
                // For each card - three per column
                $cardDesc.each((index, card) => {
                  if (index % 3 === 0) {
                    // Check if there are three cards in the row
                    if (index + 2 < $cardDesc.length) {
                      const $card1 = $(card);
                      const $card2 = $cardDesc.eq(index + 1);
                      const $card3 = $cardDesc.eq(index + 2);

                      // Match the card heights
                      const maxHeight = Math.max(
                        $card1.outerHeight(),
                        $card2.outerHeight(),
                        $card3.outerHeight(),
                      );

                      $card1.css('height', `${maxHeight}px`);
                      $card2.css('height', `${maxHeight}px`);
                      $card3.css('height', `${maxHeight}px`);
                    }
                    // The row only has two cards in a three column grid
                    else if (index + 1 < $cardDesc.length) {
                      const $card1 = $(card);
                      const $card2 = $cardDesc.eq(index + 1);

                      // Match the card heights
                      const maxHeight = Math.max(
                        $card1.outerHeight(),
                        $card2.outerHeight(),
                      );

                      $card1.css('height', `${maxHeight}px`);
                      $card2.css('height', `${maxHeight}px`);
                    }
                  }
                });
              } else if (numColumns === 4) {
                // For each card - four per column
                $cardDesc.each((index, card) => {
                  if (index % 4 === 0) {
                    // Check if there are four cards in the row
                    if (index + 3 < $cardDesc.length) {
                      const $card1 = $(card);
                      const $card2 = $cardDesc.eq(index + 1);
                      const $card3 = $cardDesc.eq(index + 2);
                      const $card4 = $cardDesc.eq(index + 3);

                      // Match the card heights
                      const maxHeight = Math.max(
                        $card1.outerHeight(),
                        $card2.outerHeight(),
                        $card3.outerHeight(),
                        $card4.outerHeight(),
                      );

                      $card1.css('height', `${maxHeight}px`);
                      $card2.css('height', `${maxHeight}px`);
                      $card3.css('height', `${maxHeight}px`);
                      $card4.css('height', `${maxHeight}px`);
                    }
                    // The row only has three cards in a four column grid
                    else if (index + 2 < $cardDesc.length) {
                      const $card1 = $(card);
                      const $card2 = $cardDesc.eq(index + 1);
                      const $card3 = $cardDesc.eq(index + 2);

                      // Match the card heights
                      const maxHeight = Math.max(
                        $card1.outerHeight(),
                        $card2.outerHeight(),
                        $card3.outerHeight(),
                      );

                      $card1.css('height', `${maxHeight}px`);
                      $card2.css('height', `${maxHeight}px`);
                      $card3.css('height', `${maxHeight}px`);
                    }
                    // The row only has two cards in a four column grid
                    else if (index + 1 < $cardDesc.length) {
                      const $card1 = $(card);
                      const $card2 = $cardDesc.eq(index + 1);

                      // Match the card heights
                      const maxHeight = Math.max(
                        $card1.outerHeight(),
                        $card2.outerHeight(),
                      );

                      $card1.css('height', `${maxHeight}px`);
                      $card2.css('height', `${maxHeight}px`);
                    }
                  }
                });
              }
            }
          };

          // Init ----------
          setCardHeights();
          let prevBreakpoint = getBreakpoint();

          const handleResize = throttle(() => {
            const currentBreakpoint = getBreakpoint();
            if (currentBreakpoint !== prevBreakpoint) {
              setCardHeights();
              prevBreakpoint = currentBreakpoint;
            }
          }, 100);

          window.addEventListener('resize', handleResize);
        },
      );
    },
  };
})(jQuery, Drupal, once);
